import { memo } from 'react';
import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;

const Title = styled.h2`
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
`;

const RequirementList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const RequirementItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Indicator = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ isMet }) => (isMet ? '#16A34A' : '#DC2626')};
  flex-shrink: 0;
  transition: background-color 0.2s ease;
`;

const RequirementText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ isMet }) => (isMet ? '#111827' : '#4B5563')};
`;

const PasswordRules = ({ rules }) => {
  const requirements = [
    { key: 'uppercase', label: 'Uma letra maiúscula' },
    { key: 'lowercase', label: 'Uma letra minúscula' },
    { key: 'number', label: 'Um número' },
    { key: 'length', label: 'No mínimo 8 caracteres' },
  ];

  return (
    <Container>
      <Title>Sua senha deve conter:</Title>
      <RequirementList>
        {requirements.map((requirement) => {
          const isMet = Boolean(rules?.[requirement.key]);

          return (
            <RequirementItem key={requirement.key}>
              <Indicator isMet={isMet} />
              <RequirementText isMet={isMet}>
                {requirement.label}
              </RequirementText>
            </RequirementItem>
          );
        })}
      </RequirementList>
    </Container>
  );
};

export default memo(PasswordRules);
